import { ReactNode } from 'react';
import classNames from 'classnames';

import { componentsBranding } from 'constants/branding';

import styles from './styles.module.scss';

type RadioButtonProps = {
  children: ReactNode;
  name: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  id?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
};

const RadioButton = ({
  children,
  name,
  value,
  checked,
  onChange,
  id,
  disabled,
  className,
  labelClassName
}: RadioButtonProps) => {
  return (
    <label className={classNames(styles.radioContainer, className)}>
      <span
        role="radio"
        aria-checked={checked}
        className={classNames(styles.radioBtn, {
          [componentsBranding.RADIO]: checked
        })}
      >
        <i
          className={classNames('fa2 fa2-radio-border', styles.borderIcon, {
            [styles.borderIcon__checked]: checked,
            [componentsBranding.RADIO_BORDER]: checked
          })}
        />
        {checked && (
          <i
            className={classNames('fa2 fa2-radio-tick', styles.tickIcon, {
              [componentsBranding.RADIO_TICK]: checked
            })}
          />
        )}
      </span>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        id={id}
        disabled={disabled}
        onChange={() => onChange(value)}
      />
      <span className={classNames(labelClassName)}>{children}</span>
    </label>
  );
};

export default RadioButton;
